import "moment/locale/ja";
import { Injectable } from '@angular/core';
import { DpadActionKey, DpadDirection, DpadKeyCode, DpadZoneType, Mode } from '@core/constants';
import { DpadHelper } from '@core/helper/dpad-helper';
import { DpadZone, DpadZoneState, ParmaGetNextZone } from '@core/models/models';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from "./local-storage.service";
import { LOCAL_STORAGE_KEY } from "@core/configs";

interface DpadFocusHistoryNode {
  screenKey: string;
  zone: DpadZoneType;
  x: number;
  y: number;
  previous: DpadFocusHistoryNode | null;
  next: DpadFocusHistoryNode | null;
}

@Injectable({ providedIn: 'root' })

export class DpadControlService {

  public dZoneStateSubject = new BehaviorSubject<DpadZoneState>({
    dZone: DpadZoneType.SCREEN,
    dX: DpadZoneType.DEFAULT,
    dY: DpadZoneType.DEFAULT,
    dKey: DpadKeyCode.KEYCODE_DEFAULT
  });
  public dZoneState$ = this.dZoneStateSubject.asObservable();

  onBackCallback: any;
  onSelectMenuCallback: any;
  onOutMenuCallback: any;
  currentZoneType: DpadZoneType = DpadZoneType.SCREEN;
  selectDpadX = -1;
  selectDpadY = -1;
  beforeOpenDialZoneType = -1;
  beforeSelectDpadX = -1;
  beforeSelectDpadY = -1;
  beforeSelectMenuDpadX = 0;
  beforeSelectMenuDpadY = 1;
  beforeSelectUserSettingMidDpadY = -1;
  beforeSelectUserSettingRightDpadY = -1;
  tabDpad = -1;
  lstIndexDpad: { [key: string]: number[] } = {}
  lstIndexTabDpad?: { [key: string]: number[] } = {}
  screenStyle: string = 'default'
  dZoneScreen: DpadZone = {
    dType: DpadZoneType.SCREEN,
    dXMin: DpadZoneType.DEFAULT,
    dXMax: DpadZoneType.DEFAULT,
    dYMin: DpadZoneType.DEFAULT,
    dYMax: DpadZoneType.DEFAULT
  }
  dZoneLogin: DpadZone = {
    dType: DpadZoneType.LOG_IN,
    dXMin: DpadZoneType.DEFAULT,
    dXMax: DpadZoneType.DEFAULT,
    dYMin: DpadZoneType.DEFAULT,
    dYMax: DpadZoneType.DEFAULT
  }
  dZoneSubHeader: DpadZone = {
    dType: DpadZoneType.SUB_HEADER,
    dXMin: DpadZoneType.MEMU,
    dXMax: DpadZoneType.DEFAULT,
    dYMin: DpadZoneType.HEADER,
    dYMax: DpadZoneType.SCREEN
  }
  dZoneHeader: DpadZone = {
    dType: DpadZoneType.HEADER,
    dXMin: DpadZoneType.DEFAULT,
    dXMax: DpadZoneType.DEFAULT,
    dYMin: DpadZoneType.DEFAULT,
    dYMax: DpadZoneType.SUB_HEADER
  }
  dZoneMenu: DpadZone = {
    dType: DpadZoneType.MEMU,
    dXMin: DpadZoneType.DEFAULT,
    dXMax: DpadZoneType.SCREEN,
    dYMin: DpadZoneType.DEFAULT,
    dYMax: DpadZoneType.DEFAULT
  }
  dZoneTVLayout: DpadZone = {
    dType: DpadZoneType.TV_LAYOUT,
    dXMin: DpadZoneType.DEFAULT,
    dXMax: DpadZoneType.DEFAULT,
    dYMin: DpadZoneType.SCREEN,
    dYMax: DpadZoneType.DEFAULT
  }
  dZoneTvUserSettingsMid: DpadZone = {
    dType: DpadZoneType.TV_USER_SETTINGS_MID,
    dXMin: DpadZoneType.SCREEN,
    dXMax: DpadZoneType.TV_USER_SETTINGS_RIGHT,
    dYMin: DpadZoneType.DEFAULT,
    dYMax: DpadZoneType.DEFAULT
  }
  dZoneTvUserSettingsRight: DpadZone = {
    dType: DpadZoneType.TV_USER_SETTINGS_RIGHT,
    dXMin: DpadZoneType.TV_USER_SETTINGS_MID,
    dXMax: DpadZoneType.DEFAULT,
    dYMin: DpadZoneType.DEFAULT,
    dYMax: DpadZoneType.DEFAULT
  }
  dZoneTvOfficeSelect: DpadZone = {
    dType: DpadZoneType.TV_OFFICE_SELECT,
    dXMin: DpadZoneType.DEFAULT,
    dXMax: DpadZoneType.DEFAULT,
    dYMin: DpadZoneType.DEFAULT,
    dYMax: DpadZoneType.DEFAULT
  }
  dZoneTvCorpLogin: DpadZone = {
    dType: DpadZoneType.TV_CORP_LOGIN,
    dXMin: DpadZoneType.DEFAULT,
    dXMax: DpadZoneType.DEFAULT,
    dYMin: DpadZoneType.DEFAULT,
    dYMax: DpadZoneType.DEFAULT
  }
  dZoneUserDashBoard: DpadZone = {
    dType: DpadZoneType.TV_USER_DB,
    dXMin: DpadZoneType.SCREEN,
    dXMax: DpadZoneType.DEFAULT,
    dYMin: DpadZoneType.DEFAULT,
    dYMax: DpadZoneType.DEFAULT
  }
  dZoneMain: DpadZone = {
    dType: DpadZoneType.MAIN,
    dXMin: DpadZoneType.DEFAULT,
    dXMax: DpadZoneType.SCREEN,
    dYMin: DpadZoneType.DEFAULT,
    dYMax: DpadZoneType.DEFAULT
  }
  dKey: DpadKeyCode = DpadKeyCode.KEYCODE_DEFAULT;
  isDisableCenterDpad = false;
  lastHandled = 0;
  delay = 250;
  // performance.now() limit to drop the DPAD_UP the app sends after a page load (onStep) once a screen reopened on reload.
  ignoreDpadUpUntil = 0;
  moveType = 0;
  private currentFocusedElement: HTMLElement | null = null;
  private focusHistoryHead: DpadFocusHistoryNode | null = null;
  private focusHistoryTail: DpadFocusHistoryNode | null = null;

  constructor(private localStorageService: LocalStorageService){ }

  onkeyEvent(event: any){ this.onKeyDpad(event); }

  onKeyDpad(event: any){
    if(this.isDisableCenterDpad) return;
    if(event == null || event == undefined || event == "") return;
    let listItemDpad = document.querySelectorAll(`[dpad="${this.currentZoneType}"]`);
    this.lstIndexDpad = DpadHelper.getLstIndexDpad(listItemDpad);
    if(this.tabDpad != -1) {
      let listItemTabDpad = document.querySelectorAll(`[tab-dpad="${this.tabDpad}"][dpad="${this.currentZoneType}"]`);
      this.lstIndexTabDpad = DpadHelper.getLstIndexTabDpad(listItemTabDpad);
    } else this.lstIndexTabDpad = undefined;
    
    let action = -1;
    let keyCode = -1;
    try{
      action = parseInt(event.action);
      keyCode = parseInt(event.keycode);
    } catch(e){ }
    if(action == DpadActionKey.ACTION_DOWN){
      if (keyCode == DpadKeyCode.KEYCODE_DPAD_UP && performance.now() < this.ignoreDpadUpUntil) { this.ignoreDpadUpUntil = 0; return; }
      const now = Date.now();
      if (now - this.lastHandled < this.delay) return;
      this.lastHandled = now;
      this.dKey = keyCode;
      switch(keyCode){
        case DpadKeyCode.KEYCODE_DPAD_CENTER:
          this.handleKeyCenter();
          break;
        case DpadKeyCode.KEYCODE_DPAD_UP:
          this.clearCurrentFocusedItemDpad()
          this.handleKeyUp(this.lstIndexDpad, this.lstIndexTabDpad)
          this.selectItemDpad()
          break;
        case DpadKeyCode.KEYCODE_DPAD_DOWN:
          this.clearCurrentFocusedItemDpad()
          this.handleKeyDown(this.lstIndexDpad, this.lstIndexTabDpad)
          this.selectItemDpad()
          break;
        case DpadKeyCode.KEYCODE_DPAD_LEFT:
          if(this.tabDpad != -1 && this.selectDpadY == 0){
            let listItemDpadTab = document.querySelectorAll(`[dpad="${this.currentZoneType}"]`);
            this.lstIndexDpad = DpadHelper.getLstIndexDpad(listItemDpadTab)
          }
          this.clearCurrentFocusedItemDpad()
          this.handleKeyLeft(this.lstIndexDpad, this.lstIndexTabDpad)
          this.selectItemDpad()
          break;
        case DpadKeyCode.KEYCODE_DPAD_RIGHT:
          if(this.tabDpad != -1 && this.selectDpadY == 0){
            let listItemDpadTab = document.querySelectorAll(`[dpad="${this.currentZoneType}"]`);
            this.lstIndexDpad = DpadHelper.getLstIndexDpad(listItemDpadTab)
          }
          this.clearCurrentFocusedItemDpad();
          this.handleKeyRight(this.lstIndexDpad, this.lstIndexTabDpad)
          this.selectItemDpad()
          break;
        case DpadKeyCode.KEYCODE_BACK:
        case DpadKeyCode.KEYCODE_MENU:
          this.handleKeyMenu();
          break;
        case DpadKeyCode.KEYCODE_CHANGE_UP:
        case DpadKeyCode.KEYCODE_CHANGE_DOWN:
          this.clearCurrentFocusedItemDpad();
          this.selectItemDpad();
          break;
        default:
          break;
      }
      this.subjectDpad();
    }
  }
  subjectDpad(currentZoneType: DpadZoneType = this.currentZoneType){
    if (currentZoneType === this.currentZoneType && currentZoneType !== DpadZoneType.TV_LAYOUT) {
      this.saveFocusHistory(currentZoneType, this.selectDpadX, this.selectDpadY);
    }
    this.dZoneStateSubject.next({
      dZone: currentZoneType,
      dX: this.selectDpadX,
      dY: this.selectDpadY,
      dKey: this.dKey
    });
  }

  disableCenterDpad(disable: boolean){
    if(!(window as any).AndroidBridge) return
    this.isDisableCenterDpad = disable;
    (window as any).AndroidBridge.disableCenterDpad(disable);
  }

  handleKeyCenter(){
    let select = document.querySelectorAll(`[dpad="${this.currentZoneType}"][x-dpad="${this.selectDpadX}"][y-dpad="${this.selectDpadY}"]`);
    if(this.tabDpad != -1 && this.selectDpadY != 0)
      select = document.querySelectorAll(`[tab-dpad="${this.tabDpad}"][dpad="${this.currentZoneType}"][x-tab-dpad="${this.selectDpadX}"][y-tab-dpad="${this.selectDpadY}"]`);
    if(select.length == 0) return;
    let elementItem = select[0] as HTMLElement;
    if(elementItem?.tagName.toLowerCase() === 'input') elementItem.focus();
    let clickTarget = elementItem;
    const isToggleSwitch = elementItem?.tagName.toLowerCase() === 'p-toggleswitch';
    if(isToggleSwitch)
      clickTarget = elementItem.childNodes[0] as HTMLElement;
    const event = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true
    });
    clickTarget.dispatchEvent(event);
    if(isToggleSwitch)
      setTimeout(() => (document.activeElement as HTMLElement)?.blur(), 0);
    let tabDpab = elementItem.getAttribute('tab-dpad');
    if(tabDpab) this.tabDpad = parseInt(tabDpab)
    else this.tabDpad = -1;
  }

  handleKeyMenu(){
    if(this.currentZoneType == DpadZoneType.TV_LAYOUT){
      this.restoreLastScreenFocusState();
    } else if(
        this.currentZoneType == DpadZoneType.SCREEN || 
        this.currentZoneType == DpadZoneType.TV_USER_SETTINGS_MID ||  
        this.currentZoneType == DpadZoneType.TV_USER_SETTINGS_RIGHT ||
        this.currentZoneType == DpadZoneType.TV_USER_DB ||
        this.currentZoneType == DpadZoneType.MAIN
      )
    {
      this.saveFocusHistory(this.currentZoneType, this.selectDpadX, this.selectDpadY);
      this.currentZoneType = DpadZoneType.TV_LAYOUT;
      this.selectDpadX = this.beforeSelectMenuDpadX;
      this.selectDpadY = this.beforeSelectMenuDpadY;
    }
    this.clearSelectItemDpad();
    this.selectItemDpad();
  }

  restoreScreenFocusFromTvLayout(): boolean {
    if (this.currentZoneType !== DpadZoneType.TV_LAYOUT) return false;

    this.restoreLastScreenFocusState();
    this.clearSelectItemDpad();
    this.selectItemDpad();
    this.subjectDpad();
    return true;
  }

  initFirstAccess(){
    this.currentZoneType = DpadZoneType.TV_LAYOUT;
    this.clearSelectItemDpad();
    this.selectDpadX = 0;
    this.selectDpadY = 1;
    this.beforeSelectMenuDpadX = 0;
    this.beforeSelectMenuDpadY = 1;
    this.selectItemDpad();
    this.subjectDpad();
    this.onBackCallback = null;
  }

  handleKeyUp(lstIndexDpad: any, lstIndexTabDpad: any){
    let select = document.querySelectorAll(`[dpad="${this.currentZoneType}"][x-dpad="${this.selectDpadX}"][y-dpad="${this.selectDpadY}"]`);
    if(this.tabDpad != -1 && this.selectDpadY != 0)
      select = document.querySelectorAll(`[tab-dpad="${this.tabDpad}"][dpad="${this.currentZoneType}"][x-tab-dpad="${this.selectDpadX}"][y-tab-dpad="${this.selectDpadY}"]`);
    let elementItem = select[0] as HTMLElement;
    let minItemY = DpadHelper.getMinItemY(lstIndexDpad);
    if(this.tabDpad != -1) minItemY = DpadHelper.getMinItemY(lstIndexTabDpad);
    this.selectDpadY--;
    if(this.selectDpadY < minItemY){
      if(this.currentZoneType == DpadZoneType.MAIN){
        let maxItemY = DpadHelper.getMaxItemY(lstIndexDpad);
          this.selectDpadY = maxItemY;
      }else this.selectDpadY = minItemY;
      this.changeDpadZone(DpadDirection.UP);
    } else{
      let selectNext = document.querySelectorAll(`[dpad="${this.currentZoneType}"][y-dpad="${this.selectDpadY}"]`);
      if(this.tabDpad != -1 && this.selectDpadY != 0)
        selectNext = document.querySelectorAll(`[tab-dpad="${this.tabDpad}"][dpad="${this.currentZoneType}"][y-tab-dpad="${this.selectDpadY}"]`);
      if(elementItem && selectNext.length > 0){
        let nodeClosest = this.getClosestElement(elementItem, selectNext);
        if(nodeClosest){
          let xddpad = nodeClosest.getAttribute('x-dpad');
          if(this.tabDpad != -1 && this.selectDpadY != 0) xddpad = nodeClosest.getAttribute('x-tab-dpad');
          if(xddpad) this.selectDpadX = parseInt(xddpad);
        }
      }
    }
  }

  getClosestElement(node: HTMLElement, candidates: NodeListOf<Element>): HTMLElement | null {
    if(!node) return null;
    const nodeRect = node.getBoundingClientRect();
    const nodeCenterX = nodeRect.left + nodeRect.width / 2;
    const nodeCenterY = nodeRect.top + nodeRect.height / 2;
    let closestEl: HTMLElement | null = null;
    let minDistance = Number.POSITIVE_INFINITY;
    candidates.forEach((el) => {
      if(el === node) return;
      const rect = el.getBoundingClientRect();
      const elCenterX = rect.left + rect.width / 2;
      const elCenterY = rect.top + rect.height / 2;
      const dx = elCenterX - nodeCenterX;
      const dy = elCenterY - nodeCenterY;
      const distance = Math.hypot(dx, dy);
      if(distance < minDistance){
        minDistance = distance;
        closestEl = el as HTMLElement;
      }
    });
    return closestEl;
  }
  handleKeyDown(lstIndexDpad: any, lstIndexTabDpad: any){
    let select = document.querySelectorAll(`[dpad="${this.currentZoneType}"][x-dpad="${this.selectDpadX}"][y-dpad="${this.selectDpadY}"]`);
    if (this.tabDpad != -1 && this.selectDpadY != 0)
      select = document.querySelectorAll(`[tab-dpad="${this.tabDpad}"][dpad="${this.currentZoneType}"][x-tab-dpad="${this.selectDpadX}"][y-tab-dpad="${this.selectDpadY}"]`);
    let elementItem = select[0] as HTMLElement;
    let maxItemY = DpadHelper.getMaxItemY(lstIndexDpad);
    if(this.tabDpad != -1) maxItemY = DpadHelper.getMaxItemY(lstIndexTabDpad);
    if(this.selectDpadX == -1) this.selectDpadX = 0;
    this.selectDpadY++;
    if(this.selectDpadY > maxItemY){
      if(this.currentZoneType == DpadZoneType.MAIN) this.selectDpadY = 0;
      else this.selectDpadY = maxItemY;
      this.changeDpadZone(DpadDirection.DOWN);
    } else{
      let selectNext = document.querySelectorAll(`[dpad="${this.currentZoneType}"][y-dpad="${this.selectDpadY}"]`);
      if(this.tabDpad != -1 && this.selectDpadY != 0)
        selectNext = document.querySelectorAll(`[tab-dpad="${this.tabDpad}"][dpad="${this.currentZoneType}"][y-tab-dpad="${this.selectDpadY}"]`);
      let nodeClosest = this.getClosestElement(elementItem, selectNext);
      if(nodeClosest){
        let xddpad = nodeClosest.getAttribute('x-dpad');
        if(this.tabDpad != -1 && this.selectDpadY != 0) xddpad = nodeClosest.getAttribute('x-tab-dpad');
        if(xddpad) this.selectDpadX = parseInt(xddpad);
      }
    }
  }

  handleKeyLeft(lstIndexDpad: any, lstIndexTabDpad: any){
    if(this.selectDpadY == -1) this.selectDpadY = 0
    let minItemX = DpadHelper.getMinItemX(lstIndexDpad, this.selectDpadY);
    if(this.tabDpad != -1 && this.selectDpadY != 0) minItemX = DpadHelper.getMinItemX(lstIndexTabDpad, this.selectDpadY);
    this.selectDpadX--;
    if(this.selectDpadX < minItemX){
      if(this.currentZoneType == DpadZoneType.SCREEN && this.moveType == 1){
        let maxItemX = DpadHelper.getMaxItemX(lstIndexDpad, this.selectDpadY);
        this.selectDpadX = maxItemX;
      }
      else this.selectDpadX = minItemX;
      this.changeDpadZone(DpadDirection.LEFT);
    }
  }

  handleKeyRight(lstIndexDpad: any, lstIndexTabDpad: any){
    if(this.selectDpadY == -1) this.selectDpadY = 0
    let maxItemX = DpadHelper.getMaxItemX(lstIndexDpad, this.selectDpadY);
    if(this.tabDpad != -1 && this.selectDpadY != 0) maxItemX = DpadHelper.getMaxItemX(lstIndexTabDpad, this.selectDpadY);
    this.selectDpadX++;
    if(this.selectDpadX > maxItemX){
      if(this.currentZoneType == DpadZoneType.SCREEN && this.moveType == 1) this.selectDpadX = 0;
      else this.selectDpadX = maxItemX;
      this.changeDpadZone(DpadDirection.RIGHT);
    }
  }

  changeDpadZone(dpadDirection: string){
    let parmaGetNextZone: ParmaGetNextZone = {
      dpadDirection: dpadDirection,
      currentZoneType: this.currentZoneType,
      configDpadZoneHeader: this.dZoneHeader,
      configDpadZoneSubHeader: this.dZoneSubHeader,
      configDpadZoneMenu: this.dZoneMenu,
      configDpadZoneScreen: this.dZoneScreen,
      configDpadZoneLogin: this.dZoneLogin,
      configDpadZoneTvLayout: this.dZoneTVLayout,
      configDpadZoneTvOfficeSelect: this.dZoneTvOfficeSelect,
      configDpadZoneTvUserSettingsMid: this.dZoneTvUserSettingsMid,
      configDpadZoneTvUserSettingsRight: this.dZoneTvUserSettingsRight,
      configDpadZoneUserDashBoard: this.dZoneUserDashBoard,
      configDpadZoneTvCorpLogin: this.dZoneTvCorpLogin,
      configDpadZoneMain: this.dZoneMain
    }
    let nextZone = DpadHelper.getNextZone(parmaGetNextZone)
    let zonecurrent = this.currentZoneType;
    if(nextZone != -1){
      this.currentZoneType = nextZone;
      this.selectDpadY = 0;
      this.selectDpadX = 0;
      if(this.currentZoneType == DpadZoneType.HEADER) this.selectDpadX = 1;
      if(this.currentZoneType == DpadZoneType.SCREEN && this.beforeSelectUserSettingMidDpadY != -1)
        this.selectDpadY = this.beforeSelectUserSettingMidDpadY;
      if(this.currentZoneType == DpadZoneType.TV_USER_SETTINGS_MID || this.currentZoneType == DpadZoneType.TV_USER_DB)
        this.selectDpadY = this.beforeSelectUserSettingRightDpadY;
      if(this.currentZoneType == DpadZoneType.TV_LAYOUT){
        this.selectDpadX = this.beforeSelectMenuDpadX;
        this.selectDpadY = this.beforeSelectMenuDpadY;
      }
      if(this.currentZoneType == DpadZoneType.SCREEN && zonecurrent == DpadZoneType.MAIN) this.selectDpadY = 0;
    }
  }

  clearSelectItemDpad(){
    let items = document.querySelectorAll(`[dpad]`);
    items.forEach((ppad: any) => {
      this.clearFocusedClass(ppad as HTMLElement);
    })
    this.currentFocusedElement = null;
  }

  private clearCurrentFocusedItemDpad(){
    if(!this.currentFocusedElement){
      this.clearSelectItemDpad();
      return;
    }
    this.clearFocusedClass(this.currentFocusedElement);
    this.currentFocusedElement = null;
  }

  private clearFocusedClass(item: HTMLElement){
    let elementItem = item;
    if(elementItem.tagName.toLocaleLowerCase() == 'p-toggleswitch')
      elementItem = elementItem.childNodes[0] as HTMLElement;
    elementItem.classList.remove('dpad-unfocus');
    elementItem.classList.remove('dpad-unfocus-dark');
    if(elementItem.classList.contains('dpad-focus')){
      elementItem.classList.remove('dpad-focus');
      elementItem.classList.add('dpad-unfocus');
    }
    if(elementItem.classList.contains('dpad-focus-dark')){
      elementItem.classList.remove('dpad-focus-dark');
      elementItem.classList.add('dpad-unfocus-dark');
    }
    if(elementItem.classList.contains('dpad-focus-dark-menu')){
      elementItem.classList.remove('dpad-focus-dark-menu');
    }
    if(elementItem.classList.contains('dpad-office-select-focus')){
      elementItem.classList.remove('dpad-office-select-focus');
    }
    if(elementItem.classList.contains('dpad-focus-dark-user-setting-right')){
      elementItem.classList.remove('dpad-focus-dark-user-setting-right');
    }
    elementItem.style.zIndex = '';
    elementItem?.blur();
  }

  selectItemDpad(){
    let select = document.querySelectorAll(`[dpad="${this.currentZoneType}"][x-dpad="${this.selectDpadX}"][y-dpad="${this.selectDpadY}"]`);
    if(this.tabDpad != -1 && this.selectDpadY != 0)
      select = document.querySelectorAll(`[tab-dpad="${this.tabDpad}"][dpad="${this.currentZoneType}"][x-tab-dpad="${this.selectDpadX}"][y-tab-dpad="${this.selectDpadY}"]`);
    if(select.length == 0) return;
    let isDark = false;
    if(document.body.classList.contains('dark')) isDark = true;
    let elementItem = select[0] as HTMLElement;
    if(elementItem.tagName.toLocaleLowerCase() == 'p-toggleswitch'){
      elementItem = elementItem.childNodes[0] as HTMLElement;
      elementItem.focus();
    }
    if(elementItem?.tagName.toLowerCase() === 'select') elementItem.focus();
    this.currentFocusedElement = elementItem;
    elementItem.classList.remove('dpad-unfocus');
    elementItem.classList.remove('dpad-unfocus-dark');
    switch(this.currentZoneType){
      case DpadZoneType.HEADER:
      case DpadZoneType.SUB_HEADER:
      case DpadZoneType.LOG_IN:
      case DpadZoneType.MEMU:
        elementItem.classList.add('dpad-focus');
        elementItem.style.zIndex = '10';
        break;
      case DpadZoneType.TV_CORP_LOGIN:
      case DpadZoneType.TV_USER_DB:
      case DpadZoneType.SCREEN:
      case DpadZoneType.TV_POPUP_SELECT:
      case DpadZoneType.TV_POPUP_MULTI_SELECT:
      case DpadZoneType.MAIN:
      case DpadZoneType.DIALOG:
        if(isDark) elementItem.classList.add('dpad-focus-dark');
        else elementItem.classList.add('dpad-focus');
        elementItem.style.zIndex = '';
        break;
      case DpadZoneType.SCREEN_NON_LAYOUT:
      case DpadZoneType.TV_CORP_SELECT:
        if(this.screenStyle == 'corp-select') {
          elementItem.classList.add('dpad-office-select-focus');
        }
        else if(this.screenStyle == 'cust-login') elementItem.classList.add('dpad-focus');
        else if(this.screenStyle == 'default-dark') elementItem.classList.add('dpad-focus-dark');
        else{
          if(isDark) elementItem.classList.add('dpad-focus-dark');
          else elementItem.classList.add('dpad-focus');
        }
        elementItem.style.zIndex = '';
        break;
      case DpadZoneType.TV_LAYOUT:
        if(isDark) elementItem.classList.add('dpad-focus-dark-menu');
        else elementItem.classList.add('dpad-focus');
        break;
      case DpadZoneType.TV_OFFICE_SELECT:
        elementItem.classList.add('dpad-office-select-focus');
        break;
      case DpadZoneType.TV_USER_SETTINGS_RIGHT:
        elementItem.classList.add('dpad-focus-dark-user-setting-right');
        elementItem.style.zIndex = '10';
        break;
    }
    if(this.currentZoneType == DpadZoneType.TV_LAYOUT){
      const heightScroll = document.getElementById("heightScroll");
      if(elementItem.id != "idLogout"){
        // scroll ngang theo item giửa màn hình
        elementItem.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        });
        const offsetTop = elementItem.getBoundingClientRect().top - heightScroll!.getBoundingClientRect().top;
        const titleEl = elementItem.closest('div')?.parentElement?.parentElement?.previousElementSibling as HTMLElement;
        const dynamicOffset = elementItem.getBoundingClientRect().top - titleEl.getBoundingClientRect().top;
        heightScroll!.scrollTo({
          top: heightScroll!.scrollTop + offsetTop - dynamicOffset,
          left: heightScroll!.scrollLeft,
          behavior: "smooth"
        }); 
      }
    }
    else if(this.currentZoneType === DpadZoneType.TV_OFFICE_SELECT){
      // scroll dọc theo item giửa màn hình
      elementItem.scrollIntoView({
        behavior: 'smooth', 
        block: 'center',
        inline: 'nearest'
      });
    } else {
      // scroll dọc mặc định
      elementItem.scrollIntoView({ 
        behavior: 'smooth',
        block: 'nearest' 
      });
    }
      
    if (this.currentZoneType == DpadZoneType.MEMU && this.onSelectMenuCallback) this.onSelectMenuCallback();
    else if (this.onOutMenuCallback) this.onOutMenuCallback();
  }

  focusItem() {
    this.disableCenterDpad(false)
    let select = document.querySelectorAll(`[dpad="${this.currentZoneType}"][x-dpad="${this.selectDpadX}"][y-dpad="${this.selectDpadY}"]`);
    if(this.currentZoneType != DpadZoneType.DIALOG || select.length == 0) return
    let elementItem = select[0] as HTMLElement;
    elementItem.blur();
    elementItem.focus();
  }

  openDialog() {
    this.beforeOpenDialZoneType = this.currentZoneType;
    this.beforeSelectDpadX = this.selectDpadX;
    this.beforeSelectDpadY = this.selectDpadY;
    this.currentZoneType = DpadZoneType.DIALOG;
    this.selectDpadX = 0;
    this.selectDpadY = 0;
    this.clearSelectItemDpad();
    this.selectItemDpad()
    this.disableCenterDpad(true)
    setTimeout(() => {
      let headerDialog = document.querySelectorAll(`.p-dialog-header`);
      if(headerDialog &&  headerDialog.length >0){
        let buttonClose = headerDialog[0].querySelectorAll('.p-dialog-close-button');
        if(buttonClose && buttonClose.length > 0){
          let listItem = document.querySelectorAll(`[dpad="${this.currentZoneType}"]`);
          let lstIndexDpad = DpadHelper.getLstIndexDpad(listItem);
          let maxItemX = DpadHelper.getMaxItemX(lstIndexDpad, 0);
          buttonClose[0].setAttribute('dpad', DpadZoneType.DIALOG.toString());
          buttonClose[0].setAttribute('x-dpad', (maxItemX + 1).toString());
          buttonClose[0].setAttribute('y-dpad', '0');
          buttonClose[0].setAttribute('x-tab-dpad', '0');
          buttonClose[0].setAttribute('y-tab-dpad', '3');
          buttonClose[0].setAttribute('scale-dpad', '1.02');
          buttonClose[0].setAttribute('tab-dpad', '4');
        }
      }
      this.focusItem();
      let select = document.querySelectorAll(`[dpad="${this.currentZoneType}"][x-dpad="${this.selectDpadX}"][y-dpad="${this.selectDpadY}"]`);
      if(select.length > 0){
        let elementItem = select[0] as HTMLElement;
        let tabDpab = elementItem.getAttribute('tab-dpad');
        if (tabDpab) this.tabDpad = parseInt(tabDpab)
        else this.tabDpad = -1;
      }
    }, 1000);
  }

  setOnBackDPad(callback: any){ this.onBackCallback = callback; }
  onBackDPad(){
    this.currentZoneType = this.beforeOpenDialZoneType
    this.selectDpadX = this.beforeSelectDpadX
    this.selectDpadY = this.beforeSelectDpadY
    this.tabDpad = -1;
    this.clearSelectItemDpad();
    this.selectItemDpad()
  }

  onSelectMenu(callback: any){ this.onSelectMenuCallback = callback; }
  onOutMenu(callback: any){ this.onOutMenuCallback = callback; }

  initScreenDpad(){
    this.clearSelectItemDpad();
    this.currentZoneType = DpadZoneType.SCREEN;
    this.selectDpadX = 0;
    this.selectDpadY = 0;
    this.selectItemDpad();
  }

  onSelectMenuDpad(){
    this.saveFocusHistory(this.currentZoneType, this.selectDpadX, this.selectDpadY);
    this.clearSelectItemDpad();
    this.beforeSelectMenuDpadX = this.selectDpadX;
    this.beforeSelectMenuDpadY = this.selectDpadY;
    this.currentZoneType = this.dZoneScreen.dType;
    this.selectDpadX = 0;
    this.selectDpadY = 0;
    this.selectItemDpad();
  }

  initNoOfficeDpad(){
    this.clearSelectItemDpad();
    this.currentZoneType = DpadZoneType.TV_NO_OFFICE;
    this.selectDpadX = 0;
    this.selectDpadY = 0;
    this.selectItemDpad();
  }
  
  userSettingMenuOnClick(zone: DpadZoneType = DpadZoneType.TV_USER_SETTINGS_MID){
    this.currentZoneType = zone;
    this.clearSelectItemDpad();
    this.selectDpadX = 0;
    this.selectDpadY = 0;
    this.selectItemDpad();
  }

  userDashBoardMenuOnClick(zone: DpadZoneType = DpadZoneType.TV_USER_DB){
    this.currentZoneType = zone;
    this.clearSelectItemDpad();
    this.selectDpadX = 0;
    this.selectDpadY = 0;
    this.selectItemDpad();
  }

  goToZone(zone: DpadZoneType = DpadZoneType.SCREEN, dpadX:number = 0, dpadY:number = 0, dZoneScreen?:DpadZone){
    this.currentZoneType = zone;
    this.clearSelectItemDpad();
    this.selectDpadX = dpadX;
    this.selectDpadY = dpadY;
    this.selectItemDpad();
    if (dZoneScreen) {
      this.dZoneScreen = dZoneScreen;
    }
  }

  initUserSettingsScreen(){
    this.dZoneScreen = {
      dType: DpadZoneType.SCREEN,
      dXMin: DpadZoneType.DEFAULT,
      dXMax: DpadZoneType.TV_USER_SETTINGS_MID,
      dYMin: DpadZoneType.DEFAULT,
      dYMax: DpadZoneType.TV_LAYOUT
    }
    this.currentZoneType = DpadZoneType.SCREEN;
    this.selectDpadX = 0;
    this.selectDpadY = 0;
    this.onBackCallback = null;
    this.beforeSelectUserSettingMidDpadY = 0;
    this.beforeSelectUserSettingRightDpadY = 0;
  }

  initMultiSelectPopup(){
    this.dZoneScreen = {
      dType: DpadZoneType.TV_POPUP_MULTI_SELECT,
      dXMin: DpadZoneType.DEFAULT,
      dXMax: DpadZoneType.DEFAULT,
      dYMin: DpadZoneType.DEFAULT,
      dYMax: DpadZoneType.DEFAULT
    }
    this.currentZoneType = DpadZoneType.TV_POPUP_MULTI_SELECT;
    this.clearSelectItemDpad();
    this.selectDpadX = 0;
    this.selectDpadY = 0;
    this.selectItemDpad();
  }

  initSelectPopup(){
    this.dZoneScreen = {
      dType: DpadZoneType.TV_POPUP_SELECT,
      dXMin: DpadZoneType.DEFAULT,
      dXMax: DpadZoneType.DEFAULT,
      dYMin: DpadZoneType.DEFAULT,
      dYMax: DpadZoneType.DEFAULT
    }
    this.currentZoneType = DpadZoneType.TV_POPUP_SELECT;
    this.clearSelectItemDpad();
    this.selectDpadX = 0;
    this.selectDpadY = 0;
    this.selectItemDpad();
  }

  initUserDashboarScreen(){
    this.dZoneScreen = {
      dType: DpadZoneType.SCREEN,
      dXMin: DpadZoneType.DEFAULT,
      dXMax: DpadZoneType.TV_USER_DB,
      dYMin: DpadZoneType.DEFAULT,
      dYMax: DpadZoneType.TV_LAYOUT 
    }
    this.currentZoneType = DpadZoneType.SCREEN;
    this.selectDpadX = 0;
    this.selectDpadY = 0;
    this.onBackCallback = null;
    this.beforeSelectUserSettingMidDpadY = 0;
    this.beforeSelectUserSettingRightDpadY = 0;
  }

  saveSelectXYUserSettingScreen(dY: number){
    this.beforeSelectUserSettingMidDpadY = dY;
    this.beforeSelectUserSettingRightDpadY = 0;
  }
  
  saveSelectXYUserSettingMidScreen(dY: number){
    this.beforeSelectUserSettingRightDpadY = dY;
  }
  
  initMenuShowTvScreen(){
    this.dZoneScreen = {
      dType: DpadZoneType.SCREEN,
      dXMin: DpadZoneType.DEFAULT,
      dXMax: DpadZoneType.DEFAULT,
      dYMin: DpadZoneType.DEFAULT,
      dYMax: DpadZoneType.TV_LAYOUT
    }
    this.currentZoneType = DpadZoneType.SCREEN;
    this.selectDpadX = 0;
    this.selectDpadY = 0;
    this.onBackCallback = null;
  }
  
  setdXdY(dX: number, dY: number){
    this.clearSelectItemDpad();
    this.selectDpadX = dX;
    this.selectDpadY = dY;
    this.selectItemDpad();
  }
  setdXdYMainScreen(dX: number, dY: number){
    if(this.currentZoneType == DpadZoneType.MAIN){
      this.clearSelectItemDpad();
      this.selectDpadX = dX;
      this.selectDpadY = dY;
      this.selectItemDpad();
    }
  }

  private saveFocusHistory(zone: DpadZoneType, x: number, y: number): void {
    if (!this.isScreenHistoryZone(zone) || x < 0 || y < 0) return;

    const screenKey = this.getScreenHistoryKey();
    const existingNode = this.findFocusHistoryNode(screenKey, zone);
    if (existingNode) {
      existingNode.x = x;
      existingNode.y = y;
      this.moveFocusHistoryNodeToTail(existingNode);
      return;
    }

    const node: DpadFocusHistoryNode = {
      screenKey,
      zone,
      x,
      y,
      previous: this.focusHistoryTail,
      next: null
    };

    if (this.focusHistoryTail) this.focusHistoryTail.next = node;
    else this.focusHistoryHead = node;

    this.focusHistoryTail = node;
  }

  private getLastScreenFocusHistory(): DpadFocusHistoryNode | null {
    const screenKey = this.getScreenHistoryKey();
    let current = this.focusHistoryTail;
    while (current) {
      if (current.screenKey === screenKey) return current;
      current = current.previous;
    }
    return null;
  }

  private restoreLastScreenFocusState(): void {
    const previousFocus = this.getLastScreenFocusHistory();
    this.currentZoneType = previousFocus?.zone ?? DpadZoneType.SCREEN;
    this.selectDpadX = previousFocus?.x ?? 0;
    this.selectDpadY = previousFocus?.y ?? 0;
  }

  private findFocusHistoryNode(screenKey: string, zone: DpadZoneType): DpadFocusHistoryNode | null {
    let current = this.focusHistoryHead;
    while (current) {
      if (current.screenKey === screenKey && current.zone === zone) return current;
      current = current.next;
    }
    return null;
  }

  private moveFocusHistoryNodeToTail(node: DpadFocusHistoryNode): void {
    if (node === this.focusHistoryTail) return;

    if (node.previous) node.previous.next = node.next;
    else this.focusHistoryHead = node.next;

    if (node.next) node.next.previous = node.previous;

    node.previous = this.focusHistoryTail;
    node.next = null;

    if (this.focusHistoryTail) this.focusHistoryTail.next = node;
    this.focusHistoryTail = node;

    if (!this.focusHistoryHead) this.focusHistoryHead = node;
  }

  private getScreenHistoryKey(): string {
    return window.location.pathname.replace(/^\/+/, '').split('?')[0] || 'default';
  }

  private isScreenHistoryZone(zone: DpadZoneType): boolean {
    return zone === DpadZoneType.SCREEN
      || zone === DpadZoneType.TV_USER_SETTINGS_MID
      || zone === DpadZoneType.TV_USER_SETTINGS_RIGHT
      || zone === DpadZoneType.TV_USER_DB
      || zone === DpadZoneType.MAIN;
  }
  
  initScreenNonLayout({
    dType = DpadZoneType.SCREEN_NON_LAYOUT,
    dXMin = DpadZoneType.DEFAULT,
    dXMax = DpadZoneType.DEFAULT,
    dYMin = DpadZoneType.DEFAULT,
    dYMax = DpadZoneType.DEFAULT,
    selectDpadX = 0,
    selectDpadY = 0,
    screenStyle = 'default',
  }:{
    dType?: DpadZoneType,
    dXMin?: DpadZoneType,
    dXMax?: DpadZoneType,
    dYMin?: DpadZoneType,
    dYMax?: DpadZoneType,
    selectDpadX?: number,
    selectDpadY?: number,
    screenStyle?: string
  }){
    const mode = this.localStorageService.getItem(LOCAL_STORAGE_KEY.mode) || Mode.WEB;
    if(mode == Mode.WEB) return;
    this.clearSelectItemDpad();
    this.dZoneScreen = {
      dType: dType,
      dXMin: dXMin,
      dXMax: dXMax,
      dYMin: dYMin,
      dYMax: dYMax
    }
    this.currentZoneType = this.dZoneScreen.dType;
    this.selectDpadX = selectDpadX;
    this.selectDpadY = selectDpadY;
    this.screenStyle = screenStyle;
    this.selectItemDpad();
  }
  initScreen({
    dType = DpadZoneType.SCREEN,
    dXMin = DpadZoneType.DEFAULT,
    dXMax = DpadZoneType.DEFAULT,
    dYMin = DpadZoneType.DEFAULT,
    dYMax = DpadZoneType.DEFAULT,
    selectDpadX = 0,
    selectDpadY = 0,
    screenStyle = 'default',
    moveType = 0,
  }:{
    dType?: DpadZoneType,
    dXMin?: DpadZoneType,
    dXMax?: DpadZoneType,
    dYMin?: DpadZoneType,
    dYMax?: DpadZoneType,
    selectDpadX?: number,
    selectDpadY?: number,
    screenStyle?: string,
    moveType?: number
  }){
    const mode = this.localStorageService.getItem(LOCAL_STORAGE_KEY.mode) || Mode.WEB;
    if(mode == Mode.WEB) return;
    this.clearSelectItemDpad();
    this.dZoneScreen = {
      dType: dType,
      dXMin: dXMin,
      dXMax: dXMax,
      dYMin: dYMin,
      dYMax: dYMax
    }
    this.currentZoneType = dType;
    this.selectDpadX = selectDpadX;
    this.selectDpadY = selectDpadY;
    this.screenStyle = screenStyle;
    this.moveType = moveType;
    this.selectItemDpad();
  }
  dialogScreen() {
    const mode = this.localStorageService.getItem(LOCAL_STORAGE_KEY.mode) || Mode.WEB;
    if (mode == Mode.WEB) return;
    this.clearSelectItemDpad();
    this.currentZoneType = DpadZoneType.DIALOG;
    this.selectDpadX = 0;
    this.selectDpadY = 0;
    this.selectItemDpad();
  }
}
